export interface SalesStats {
  totalSalesMTD: string;
  ordersMTD: number;
  salesReps: number;
  avgDealSize: string;
}

export interface SalesRepItem {
  id: string;
  rank: number;
  initials: string;
  name: string;
  revenue: number;
  marginPercent: number;
  customers: number;
  target: number;
  achievement: number;
  commission: number;
}

export const ITEMS_PER_PAGE = 10;
